export default __webpack_public_path__ + "assets/Email.5c7e.svg";